import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error'
import { useNavigate } from "react-router-dom";
const UploadRecord = ({ work_order, onWorkOrderChange }) => {

    const navigate = useNavigate();

    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [medicalRecordFile, setMedicalRecordFile] = useState(null);
    const [medicalRecordFileAdd, setMedicalRecordFileAdd] = useState(null);
    // additional records
    const [medicalRecordAdditionalFile1, setMedicalRecordAdditionalFile1] = useState(null);
    const [medicalRecordAdditionalFile2, setMedicalRecordAdditionalFile2] = useState(null);
    



    useEffect(() => {

        if (work_order?.work_order_id > 0 && work_order?.work_order_id >= 4) {
            setMedicalRecordFile({ medical_record_file: work_order?.medical_record_file, medical_record_notes: work_order?.medical_record_notes });
        }

        setMedicalRecordAdditionalFile1({
            medical_record_optional_file_1: work_order?.medical_record_optional_file_1,
            medical_record_optional_notes_1: work_order?.medical_record_optional_notes_1
        });
        setMedicalRecordAdditionalFile2({
            medical_record_optional_file_2: work_order?.medical_record_optional_file_2,
            medical_record_optional_notes_2: work_order?.medical_record_optional_notes_2
        });

    }, [work_order?.work_order_id]);



    const removeMedicalRecordFile = async (e) => {


        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-medical-record-file",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setMedicalRecordFile(null)
                    onWorkOrderChange({
                        medical_record_file: null,
                        medical_record_notes: null,
                        status: 1.0,

                    });


                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                }
                setIsBtn(false)


            }).catch(function (error) {
                catchError(error, navigate)

            });



    }


    const resetMedicalRecordFile = async (e) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/reset-medical-record-file",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    //  setMedicalRecordFile(null);


                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                }
                setIsBtn(false)


            }).catch(function (error) {
                catchError(error, navigate)

            });



    }


    const addMedicalRecordFile = async () => {

        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
            medical_record_fil: medicalRecordFileAdd.medical_record_file,
            medical_record_notes: medicalRecordFileAdd?.medical_record_notes,
        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-medical-record-file", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setMedicalRecordFile({ ...medicalRecordFile, medical_record_file: response?.data?.medical_record_file, medical_record_notes: medicalRecordFileAdd?.medical_record_notes })
                onWorkOrderChange({
                    medical_record_file: response?.data?.medical_record_file,
                    medical_record_notes: medicalRecordFileAdd?.medical_record_notes,
                    status: 4,

                });
                setAddMode(false);

            } else {

                Swal.fire({ icon: "error", title: "wo Info", text: "Medical Record File has not been submitted. Please try again" });

            }
            setIsBtn(false);
        }).catch(function (error) {

            catchError(error, navigate)


        });


    }





    const removeUnapprovedMedicalRecord = async (e) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-unapproved-medical-record",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    onWorkOrderChange({
                        unapproved_medical_record: null,
                    });

                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                }
                setIsBtn(false)


            }).catch(function (error) {
                catchError(error, navigate)

            });



    }



    const approveUnapprovedMedicalRecord = async (e) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/approve-unapproved-medical-record",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    onWorkOrderChange({
                        medical_record_file: response?.data?.medical_record,
                        unapproved_medical_record: null,
                        status: 4,

                    });


                } else {
                    Swal.fire({ icon: "error", title: "Medical Record", text: response?.data?.message });
                }
                setIsBtn(false)


            }).catch(function (error) {
                catchError(error, navigate)

            });



    }

    // ---------------- ADDITIONAL FILE 1 ----------------
    const addMedicalRecordFile1 = async () => {
        setIsBtn(true);
let auth = {
            work_order_id: work_order.work_order_id,
            medical_record_optional_file_1: medicalRecordAdditionalFile1?.medical_record_optional_file_1,
            medical_record_optional_notes_1: medicalRecordAdditionalFile1?.medical_record_optional_notes_1,
        };

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-medical-record-optional-file-1", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {
            if (response?.data?.status) {
                setMedicalRecordAdditionalFile1({ 
                    medical_record_optional_file_1: response?.data?.medical_record_optional_file_1,
                    medical_record_optional_notes_1: response?.data?.medical_record_optional_notes_1
                })
                onWorkOrderChange({
                    medical_record_optional_file_1: response?.data?.medical_record_optional_file_1,
                    medical_record_optional_notes_1: response?.data?.medical_record_optional_notes_1,
                    status: 4,
                });
            } else {
                Swal.fire({ icon: "error", title: "wo Info", text: "Additional Record 1 has not been submitted. Please try again" });
            }
            setIsBtn(false);
        }).catch(function (error) {
            catchError(error, navigate);
        });
    };



    const removeMedicalRecordFile1 = async () => {
        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-medical-record-optional-file-1",
            { work_order_id: work_order?.work_order_id },
            { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
        ).then(function (response) {
            if (response?.data?.status) {
                setMedicalRecordAdditionalFile1(null)
                onWorkOrderChange({
                     medical_record_optional_file_1: null,
                     medical_record_optional_notes_1: null
                });
            } else {
                Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
            }
            setIsBtn(false)
        }).catch(function (error) {
            catchError(error, navigate)
        });
    };




    // ---------------- ADDITIONAL FILE 2 ----------------
    const addMedicalRecordFile2 = async () => {
        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
            medical_record_optional_file_2: medicalRecordAdditionalFile2?.medical_record_optional_file_2,
            medical_record_optional_notes_2: medicalRecordAdditionalFile2?.medical_record_optional_notes_2,     
        };

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-medical-record-optional-file-2", auth, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true
        }).then(function (response) {
            if (response?.data?.status) {
                setMedicalRecordAdditionalFile2({ 
                    medical_record_optional_file_2: response?.data?.medical_record_optional_file_2,
                    medical_record_optional_notes_2: response?.data?.medical_record_optional_notes_2
                })
                onWorkOrderChange({
                    medical_record_optional_file_2: response?.data?.medical_record_optional_file_2,
                    medical_record_optional_notes_2: response?.data?.medical_record_optional_notes_2,
                });
            } else {
                Swal.fire({ icon: "error", title: "wo Info", text: "Additional Record 2 has not been submitted. Please try again" });
            }
            setIsBtn(false);
        }).catch(function (error) {
            catchError(error, navigate);
        });
    };

    const removeMedicalRecordFile2 = async () => {
        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-medical-record-optional-file-2",
            { work_order_id: work_order?.work_order_id },
            { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
        ).then(function (response) {
            if (response?.data?.status) {
                setMedicalRecordAdditionalFile2(null)
                onWorkOrderChange({ medical_record_optional_file_2: null, medical_record_optional_notes_2: null });
            } else {
                Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
            }
            setIsBtn(false)
        }).catch(function (error) {
            catchError(error, navigate)
        });
    };



       // ---------------- ADDITIONAL FILE 2 ----------------
    const overrideMedicalRecordFile = async () => {
        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
        };

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/override-medical-record-file", auth, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(function (response) {
            if (response?.data?.status) {
                onWorkOrderChange({ status: 4 });

            } else {
                Swal.fire({ icon: "error", title: "wo Info", text: "Medical record has not been overridden. Please try again" });
            }
            setIsBtn(false);
        }).catch(function (error) {
            catchError(error, navigate);
        });
    };


    return (
        <>


            {(work_order && work_order?.authorization_status == 1 && work_order?.status >= 1) &&
                <>
                    <div className="row mt-2 mx-0 sub-heading">
                        <div className="col py-1 d-inline-flex align-items-center flex-wrap">
    <div className="px-0 fw-bold text-dark mb-0">
        MEDICAL RECORD <span className="text-danger fw-bold">({work_order?.work_order_no})</span>
    </div>
    {work_order?.download_status == 2 && work_order?.missing_reason && (
        <div className="text-danger small fw-bold ms-3">
            Missing Reason: <span className="text-dark fw-normal">{work_order.missing_reason}</span>
        </div>
    )}
</div>
                        {(work_order?.status >= 1) &&
                            <div className="col py-1 text-end">

                                {addMode ?
                                    <button onClick={() => { setAddMode(false); setMedicalRecordFileAdd(null) }} className="btn btn-sm  btn-success me-1 mt-1" type="button">Cancel Upload Record</button>
                                    :
                                    <>
                                        {work_order?.status < 4 &&
                                          <>
                                            <button onClick={() => { setAddMode(true); setMedicalRecordFileAdd(null) }} className="btn btn-sm  btn-success me-1 mt-1" type="button">Upload Record</button>
                                            <button onClick={() => {  overrideMedicalRecordFile() }} className="btn btn-sm  btn-warning me-1 mt-1" type="button">Override Record</button>
                                          </>
                                        }
                                    </>
                                }
                            </div>
                        }

                    </div>
                    {(addMode && !work_order?.medical_record_file) ?
                        <>
                            <div className="row px-0 py-2 gx-2 my-2 mx-4">
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <div className="input-group ">
                                        <input name="medical_record_file" id="medical_record_file" type="file" className="form-control"
                                            accept="pdf/*"
                                            onChange={(e) => {
                                                setMedicalRecordFileAdd({ ...medicalRecordFileAdd, medical_record_file: e.target.files[0] })
                                            }}

                                        />
                                        <input name="medical_record_notes" id="medical_record_notes"
                                            className="form-control mx-1"
                                            placeholder="Add your notes here!"
                                            value={medicalRecordFileAdd?.medical_record_notes}
                                            onChange={(e) =>
                                                setMedicalRecordFileAdd({ ...medicalRecordFileAdd, medical_record_notes: e.target.value })
                                            }
                                        />
                                        <a className="btn btn-sm btn-success " href="javascript:void(0)" onClick={(e) =>
                                            addMedicalRecordFile()} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}</a>


                                    </div>


                                </div>
                            </div>


                        </>

                        :
                        <>
                            {(work_order?.unapproved_medical_record) &&

                                <div className="row px-0 py-2 gx-2 my-4 mx-4">
                                    <div className="col-xl-12 col-lg-12 col-sm-12">
                                        <font class="fw-bold text-danger">FACILITY HAS UPLOADED MEDICAL RECORD</font>
                                        <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-unapproved-medical-record/" + work_order.work_order_id} target="_blank" >DOWNLOAD</a>
                                        <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeUnapprovedMedicalRecord} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "REMOVE"}</a>
                                        <a className="btn btn-sm btn-sm btn-danger ms-1" href="javascript:void(0)" onClick={approveUnapprovedMedicalRecord} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "APPROVE"}</a>
                                    </div>
                                </div>

                            }
                            {(work_order?.status >= 4 ) ?
                                <>

                                {(work_order?.medical_record_file == null) ?
                                    <div className="row px-0 py-2 gx-2 my-4 mx-4">
                                        <div className="col-xl-12 col-lg-12 col-sm-12">
                                            <font class="fw-bold text-danger">MEDICAL RECORD FILES ARE BEING OVERRIDEN. </font>
                                            <button onClick={() => { setAddMode(true); setMedicalRecordFileAdd(null) }} className="btn btn-sm  btn-success me-1 mt-1" type="button">Upload Record</button>

                                        </div>
                                    </div>
                                    :
                                    <>
                                        <div className="row px-0 py-2 gx-2 my-4 mx-4">
                                            <div className="col-xl-12 col-lg-12 col-sm-12">
                                                <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-medical-record-file/" + work_order.work_order_id} target="_blank" >DOWNLOAD</a>
                                                <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeMedicalRecordFile} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</a>
                                                <a className="btn btn-sm btn-sm btn-danger ms-1" href="javascript:void(0)" onClick={resetMedicalRecordFile} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "RESET DOWNLOAD DATE"}</a>
                                            </div>
                                        </div>

                                        {(work_order?.status >= 4) &&
                                            <>
                                                <div class="row mt-2 mx-0 sub-heading pt-3 pb-2">
                                                    <div className="col-12">
                                                        <h6 className="fw-bold">ADDITIONAL RECORDS (UP TO 2)</h6>
                                                    </div>
                                                </div>



                                                <div className="row px-0 py-2 gx-2 my-4 mx-4">
                                                    {(work_order?.medical_record_optional_file_1) ?

                                                        <div className="col-xl-6 col-lg-6 col-sm-12">
                                                            <div className="input-group ">
                                                                <a className="btn btn-sm btn-primary"
                                                                    href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-medical-record-optional-file-1/" + work_order.work_order_id}
                                                                    target="_blank" rel="noopener noreferrer">
                                                                    DOWNLOAD
                                                                </a>
                                                                <a className="btn btn-sm btn-warning ms-1"
                                                                    href="javascript:void(0)"
                                                                    onClick={removeMedicalRecordFile1}
                                                                    disabled={isBtn}>
                                                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div>Loading...</> : "REMOVE"}
                                                                </a>
                                                                <span className="mx-2">{work_order?.medical_record_optional_notes_1}</span> 
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="col-xl-6 col-lg-6 col-sm-12">
                                                            <div className="input-group ">
                                                                <input type="file" className="form-control"
                                                                    accept="pdf/*"
                                                                    onChange={(e) =>
                                                                        setMedicalRecordAdditionalFile1({ medical_record_optional_file_1: e.target.files[0] })
                                                                    }
                                                                />
                                                                <input type="text" className="form-control" placeholder="Notes"
                                                                    value={medicalRecordAdditionalFile1?.medical_record_optional_notes_1 || ""}
                                                                    onChange={(e) =>
                                                                        setMedicalRecordAdditionalFile1({ ...medicalRecordAdditionalFile1, medical_record_optional_notes_1: e.target.value })
                                                                    }
                                                                />
                                                             
                                                                <a className="btn btn-sm btn-success"
                                                                    href="javascript:void(0)"
                                                                    onClick={addMedicalRecordFile1}
                                                                    disabled={isBtn}>
                                                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div>Loading...</> : "UPLOAD"}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    }

                                                    {(work_order?.medical_record_optional_file_2) ?


                                                        <div className="col-xl-6 col-lg-6 col-sm-12">
                                                            <div className="input-group ">
                                                                <a className="btn btn-sm btn-primary"
                                                                    href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-medical-record-optional-file-2/" + work_order.work_order_id}
                                                                    target="_blank" rel="noopener noreferrer">
                                                                    DOWNLOAD
                                                                </a>
                                                                <a className="btn btn-sm btn-warning ms-1"
                                                                    href="javascript:void(0)"
                                                                    onClick={removeMedicalRecordFile2}
                                                                    disabled={isBtn}>
                                                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div>Loading...</> : "REMOVE"}
                                                                </a>
                                                                <span className="mx-2">{work_order?.medical_record_optional_notes_2}</span>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="col-xl-6 col-lg-6 col-sm-12">
                                                            <div className="input-group ">
                                                                <input type="file" className="form-control"
                                                                    accept="pdf/*"
                                                                    onChange={(e) =>
                                                                        setMedicalRecordAdditionalFile2({ medical_record_optional_file_2: e.target.files[0] })
                                                                    }
                                                                />
                                                                <input type="text" className="form-control" placeholder="Notes"
                                                                    value={medicalRecordAdditionalFile2?.medical_record_optional_notes_2 || ""}
                                                                    onChange={(e) =>
                                                                        setMedicalRecordAdditionalFile2({ ...medicalRecordAdditionalFile2, medical_record_optional_notes_2: e.target.value })
                                                                    }
                                                                />
                                                                <a className="btn btn-sm btn-success"
                                                                    href="javascript:void(0)"
                                                                    onClick={addMedicalRecordFile2}
                                                                    disabled={isBtn}>
                                                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div>Loading...</> : "UPLOAD"}
                                                                </a>
                                                            </div>
                                                        </div>

                                                    }




                                                </div>
                                            </>
                                        }

                                    </>
                                }


                                </>
                                :
                                <div className="row " >

                                    <div className="col-xl-12 col-lg-12 py-4 px-5" >

                                        <h5>Medical record has not been uploaded yet.</h5>

                                    </div>

                                </div>
                            }
                        </>
                    }
                </>
            }



        </>

    )

}
export default UploadRecord;